import { useEffect, useState } from "react";
import axios from "axios";
import { Mail, MapPin, Phone } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Footer() {
  const [logo, setLogo] = useState(null);
  useEffect(() => {
    axios.get(`${API}/branding`).then((r) => setLogo(r.data.logo_path)).catch(() => {});
  }, []);
  return (
    <footer className="bg-slate-950 text-slate-300 py-16 px-6 md:px-12 lg:px-24" data-testid="footer">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          {logo ? (
            <span className="inline-block bg-white px-3 py-2 rounded-sm" data-testid="footer-logo-chip">
              <img src={`${API}/files/${logo}`} alt="ASAP Glass & Aluminium" className="h-10 w-auto" data-testid="footer-logo-image" />
            </span>
          ) : (
            <p className="font-outfit font-semibold text-white text-lg">
              ASAP <span className="text-sky-400">Glass</span> &amp; Aluminium
            </p>
          )}
          <p className="mt-4 text-sm leading-relaxed text-slate-400 max-w-xs">
            Glass replacement, aluminium windows &amp; doors, shower screens, shopfronts, mirrors and splashbacks across South-West Sydney.
          </p>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-5">Contact</p>
          <ul className="space-y-3 text-sm">
            <li>
              <a href="tel:+61404179886" data-testid="footer-phone-link" className="inline-flex items-center gap-2 hover:text-white transition-colors duration-200">
                <Phone size={14} /> 0404 179 886
              </a>
            </li>
            <li>
              <a href="mailto:matthew@asapglassnsw.com.au" data-testid="footer-email-link" className="inline-flex items-center gap-2 hover:text-white transition-colors duration-200">
                <Mail size={14} /> matthew@asapglassnsw.com.au
              </a>
            </li>
            <li className="inline-flex items-start gap-2 text-slate-400">
              <MapPin size={14} className="mt-0.5 shrink-0" /> Unit 19B / 4 Louise Avenue, Ingleburn NSW
            </li>
          </ul>
        </div>
        <div>
          <p className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-5">Quick links</p>
          <ul className="space-y-3 text-sm">
            <li><a href="#services" data-testid="footer-link-services" className="hover:text-white transition-colors duration-200">Services</a></li>
            <li><a href="#gallery" data-testid="footer-link-gallery" className="hover:text-white transition-colors duration-200">Our Work</a></li>
            <li><a href="#about" data-testid="footer-link-about" className="hover:text-white transition-colors duration-200">About Us</a></li>
            <li><a href="#contact" data-testid="footer-link-contact" className="hover:text-white transition-colors duration-200">Enquire Now</a></li>
          </ul>
        </div>
      </div>
      <div className="max-w-7xl mx-auto mt-14 pt-6 border-t border-white/10 text-xs text-slate-500 flex flex-wrap justify-between gap-4">
        <span>© {new Date().getFullYear()} ASAP Glass &amp; Aluminium. All rights reserved.</span>
        <a href="/admin/login" data-testid="footer-admin-link" className="hover:text-slate-300 transition-colors duration-200">Admin</a>
      </div>
    </footer>
  );
}
